<script lang="ts" context="module">
	export async function processDataForSideNavUpdate(data: ValueFromArray<StoreLanding["layout"]>) {
		const aisles = await firstValueFrom(
			fetchAisleData(`ca://grocery/landing-items/stores` + data?.endpoint, CacheAgeMedium).pipe(
				filter((v) => !v.loading),
				map((v) => v.payload),
			),
		);

		if (!aisles) return;

		return aisles.map(aisle => ({
			id: aisle.id,
			title: aisle.title,
			setHref: (page, item) => '/?' + query(page.url).keep(...LOCATION_PROPS, "vertical", "store").set(KEY_AISLE, item.id.toString()),
			active: (page, item) => {
				const q = query(page.url);
				return q.hasValue(KEY_AISLE, item.id.toString()) && !(q.has(BUY_AGAIN) || q.has(KEY_SUB_AISLE) || q.has(KEY_BANNER) || q.has(KEY_OCCASION))
			},
		} as SideNavMainItem));
	}

	export function fetchAisleData(url:string, msMaxCacheAge:number) {
		return fetch$<AisleData[]>(new URL(url), SPKEYS, { db: getDB(), msMaxCacheAge });
	}
</script>
<script lang="ts">
	import type { Aisle as AisleData, StoreLanding } from "$lib/def/landing";
	import type { SideNavMainItem } from "$lib/serv/nav";
	
	import { type ValueFromArray, filter, firstValueFrom, map } from "rxjs";
	import { fetch$, type Cache } from "$lib/serv/core/cache";
	import { CacheAgeMedium, SPKEYS, getDB } from "$lib/serv/groc-landing";
	import { LOCATION_PROPS } from "$lib/serv/locations";
	import { createEventDispatcher } from "svelte";
	import { query } from "$lib/util/url";
	import { KEY_BANNER } from "./Banners.svelte";
	import { KEY_OCCASION } from "./Occasions.svelte";
	import { BUY_AGAIN } from "./UserSpecificAisle.svelte";

	import Aisle, { KEY_AISLE, KEY_SUB_AISLE } from "./Aisle.svelte";
	import Grid from "$lib/ui/layout/Grid.svelte";

	export let selected: string | null;
	export let loader: Cache<AisleData[]> | undefined;

	const dispatch = createEventDispatcher();

</script>

<!-- TODO: @Dan removing 'key' function shouldn't have type issues -->
<Grid cache={loader} type="aisles" grid={!selected} key={(payload) => payload} let:item={aisle} id="aisles">
	<svelte:fragment slot="title">
		{#if !selected}
			<h3 class="headline-m bold">Shop by Aisle</h3>
		{/if}
	</svelte:fragment>
	{#if !selected || +selected === aisle.id}
		<Aisle fullscreen={!!selected} data={aisle} on:product on:nav={({detail}) => dispatch('subnav', {id: aisle.id, items: detail})} />
	{/if}
</Grid>
